import sha1 from "js-sha1"

function group1Data(store) {
  return {
    version: '1.0',
  }
}

function group2Data(store) {
  return {
    ...group1Data(store),
    is_single_fp: !!store.config.single_line,
    product: store.product || 'CW',
  }
}

function group3Data(store) {
  const { property } = store.data
  const { selectedLine } = store.selectedLine ? store : store.data

  const { unit_num } = store.config

  return {
    ...group2Data(store),
    real_estate_id: property?.real_estate_company.id,
    real_estate_name: property?.real_estate_company.company_name,
    property_id: property?.id,
    property_name: property?.property_name,
    unit_type_id: unit_num || selectedLine?.id,
    unit_type_name: selectedLine?.name,
    unit_type_bedroom_count: selectedLine?.number_of_bedrooms,
    unit_type_bathroom_count: selectedLine?.number_of_bathrooms,
    unit_type_size: selectedLine?.size_to_display,
  }
}

function group4Data(store) {
  const { selectedPackage } = store.selectedPackage ? store : store.data
  return {
    ...group3Data(store),
    design_package_id: selectedPackage?.id,
    design_package_name: selectedPackage?.name,
    vendor_id: selectedPackage?.vendor?.id,
    vendor_name: selectedPackage?.vendor?.full_name,
  }
}

function group5Data(store) {
  const { email, last_name, first_name, comments, phone } = store.formData
  return {
    ...group4Data(store),
    sparx_user_id: sha1(`${first_name}${last_name}${email}`),
    phone_no_entered: !!phone,
    user_comments: comments,
  }
}

export const analyticsEvents = {
  PAGE_LOADED: {
    name: 'page_loaded',
    data: group2Data,
  },
  WELCOME_SCREEN_VIEWED: {
    name: 'welcome_screen_viewed',
    data: group3Data,
  },
  START_EXPLORING_TAPPED: {
    name: 'start_exploring_tapped',
    data: group3Data,
  },
  HOME_SCREEN_VIEWED: {
    name: 'home_screen_viewed',
    data: group4Data,
  },
  FLOOR_PLAN_TAPPED: {
    name: 'floor_plan_tapped',
    data: group4Data,
  },
  FLOOR_PLAN_SELECTION_SCREEN_VIEW: {
    name: 'floor_plan_selection_screen_view',
    data: group4Data,
  },
  FLOOR_PLAN_SELECTION_SCREEN_CLOSE: {
    name: 'floor_plan_selection_screen_close',
    data: group4Data,
  },
  FLOOR_PLAN_SELECTED: {
    name: 'floor_plan_selected',
    data: group4Data,
  },
  PACKAGE_SELECTED: {
    name: 'package_selected',
    data: group4Data,
  },
  PACKAGE_INFO_TAPPED: {
    name: 'package_info_tapped',
    data: group4Data,
  },
  PACKAGE_INFO_VIEWED: {
    name: 'package_info_viewed',
    data: group4Data,
  },
  PACKAGE_INFO_CLOSED: {
    name: 'package_info_closed',
    data: group4Data,
  },
  DISCLAIMER_TAPPED: {
    name: 'disclaimer_tapped',
    data: group4Data,
  },
  DISCLAIMER_VIEWED: {
    name: 'disclaimer_viewed',
    data: group4Data,
  },
  DISCLAIMER_CLOSED: {
    name: 'disclaimer_closed',
    data: group4Data,
  },
  LEVEL_TAPPED: {
    name: 'level_tapped',
    data: group4Data,
  },
  LEVEL_SELECTED: {
    name: 'level_selected',
    data: group4Data,
  },
  RESET_TAPPED: {
    name: 'reset_tapped',
    data: group4Data,
  },
  TOPVIEW_TAPPED: {
    name: 'topview_tapped',
    data: group4Data,
  },
  CONTACT_US_TAPPED: {
    name: 'contact_us_tapped',
    data: group4Data,
  },
  CORT_FORM_VIEWED: {
    name: 'cort_form_viewed',
    data: group4Data,
  },
  CORT_FORM_CLOSED: {
    name: 'cort_form_closed',
    data: group4Data,
  },
  CORT_SUBMIT_TAPPED: {
    name: 'cort_submit_tapped',
    data: group5Data,
  },
  SUBMIT_SUCCEEDED: {
    name: 'submit_succeeded',
    data: group5Data,
  },
  SUBMIT_SUCCEEDED_OK_TAPPED: {
    name: 'submit_succeeded_ok_tapped',
    data: group5Data,
  },
  SUBMIT_FAILED: {
    name: 'submit_failed',
    data: group5Data,
  },
  SUBMIT_FAILED_OK_TAPPED: {
    name: 'submit_failed_ok_tapped',
    data: group5Data,
  },
  CORT_CALL_TAPPED: {
    name: 'cort_call_tapped',
    data: group5Data,
  },
  CORT_TEXT_TAPPED: {
    name: 'cort_text_tapped',
    data: group5Data,
  },
  CORT_CHAT_TAPPED: {
    name: 'cort_chat_tapped',
    data: group4Data,
  },
  CORT_PRIVACY_TAPPED: {
    name: 'cort_privacy_tapped',
    data: group4Data,
  },
  CORT_WEBSITE_TAPPED: {
    name: 'cort_website_tapped',
    data: group4Data,
  },
  ENGAGED_WITH_MODEL: {
    name: 'engaged_with_model',
    data: group4Data,
  },
  EXIT_INTENT_POPUP_VIEWED: {
    name: 'exit_intent_popup_viewed',
    data: group4Data,
  },
  EXIT_INTENT_POPUP_CONNECT_TAPPED: {
    name: 'exit_intent_popup_connect_tapped',
    data: group4Data,
  },
  EXIT_INTENT_POPUP_CONNECT_SUCCEEDED: {
    name: 'exit_intent_popup_connect_succeeded',
    data: group5Data,
  },
  EXIT_INTENT_POPUP_EXIT_TAPPED: {
    name: 'exit_intent_popup_exit_tapped',
    data: group4Data,
  },
  CTA_CONVERSION_BUTTON_TAPPED: {
    name: 'cta_conversion_button_tapped',
    data: group4Data,
  }
}
